import { render } from "./FormSentSuccess.vue?vue&type=template&id=ab976b06"
import script from "./FormSentSuccess.vue?vue&type=script&lang=js"
export * from "./FormSentSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__